import { useState } from "react";
import {
  ArticleIcon,
  CaretRightIcon,
  GearFineIcon,
  GlobeIcon,
  HeartIcon,
  MapPinIcon,
  ShoppingBagIcon,
  SignOutIcon,
  UserIcon,
} from "@phosphor-icons/react";
import * as compSettings from "./settings";
import Components from "..";

const Account = ({
  id,
  extendedSettings,
  data,
  handleAccountDetail,
  handleAddresses,
  handleFavorites,
  handleOrders,
  handleLanguage,
  handleAgreements,
  confirmLogout,
  handleEdit,
}) => {
  const settings = {
    ...compSettings,
    ...extendedSettings?.[id],
  };

  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showDeleteAccountModal, setShowDeleteAccountModal] = useState(false);
  const handleLogout = () => setShowLogoutModal(true);

  const cancelLogout = () => setShowLogoutModal(false);
  const handleDeleteAccount = () => setShowDeleteAccountModal(true);
  const confirmDeleteAccount = () => {
    setShowDeleteAccountModal(false);
    confirmLogout();
  };
  const cancelDeleteAccount = () => setShowDeleteAccountModal(false);

  const logOutOnClick = () => {
    confirmLogout();
    setShowLogoutModal(false);
  };

  const menu = [
    {
      color: "text-black",
      icon: <UserIcon className="h-5 w-5" />, // ikon küçültüldü
      title: "Hesap Ayarları",
      onClick: handleAccountDetail,
      isActive: true,
    },
    {
      color: "text-black",
      icon: <MapPinIcon className="h-5 w-5" />,
      title: "Adreslerim",
      onClick: handleAddresses,
      isActive: true,
    },
    {
      color: "text-black",
      icon: <HeartIcon className="h-5 w-5" />,
      title: "Favorilerim",
      onClick: handleFavorites,
      isActive: true,
    },
    {
      color: "text-black",
      icon: <ShoppingBagIcon className="h-5 w-5" />,
      title: "Siparişlerim",
      onClick: handleOrders,
      isActive: true,
    },
    {
      color: "text-black",
      icon: <GlobeIcon className="h-5 w-5" />,
      title: "Dil",
      onClick: handleLanguage,
      isActive: false,
    },
    {
      color: "text-black",
      icon: <ArticleIcon className="h-5 w-5" />,
      title: "Tema",
      onClick: handleAgreements,
      isActive: false,
    },
    {
      color: "text-red-500",
      icon: <SignOutIcon className="h-5 w-5" />,
      title: "Çıkış Yap",
      onClick: handleLogout,
      isActive: true,
    },
    {
      color: "text-red-500",
      icon: <UserIcon className="h-5 w-5" />,
      title: "Hesabı Sil",
      onClick: handleDeleteAccount,
      isActive: true,
    },
  ];

  return (
    <div
      style={{
        paddingTop: data?.system?.safeArea?.top,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: `${settings.profilePadding.value}px`,
          borderRadius: `${settings.profileBorderRadius.value}px`,
          backgroundColor: settings.profileBackgroundColor.value,
          boxShadow: settings.showProfileShadow.value
            ? "0 1px 2px 0 rgba(0, 0, 0, 0.05)"
            : "none",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: `${settings.avatarSize.value}px`,
              height: `${settings.avatarSize.value}px`,
              borderRadius: "50%",
              border: `1px solid black`, // border rengi siyah yapıldı
              fontSize: "0.75rem", // biraz küçültüldü
              fontWeight: "600",
              color: settings.profileTextColor.value,
            }}
          >
            {data.customer?.firstName?.charAt(0).toUpperCase()}
            {data.customer?.lastName?.charAt(0).toUpperCase()}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <span
              style={{
                fontWeight: "600",
                color: settings.profileTextColor.value,
                fontSize: "0.9rem", // isim biraz küçültüldü
              }}
            >
              {data.customer?.firstName} {data.customer?.lastName}
            </span>
            <span
              style={{
                fontSize: "0.8rem", // email yazısı küçültüldü
                color: "black", // mail adresi siyah yapıldı
              }}
            >
              {data.customer?.email}
            </span>
          </div>
        </div>
        <GearFineIcon
          style={{
            width: "1.5rem",
            height: "1.5rem",
            padding: "0.2rem",
            backgroundColor: "black",
            borderRadius: "50%",
            cursor: "pointer",
          }}
          fill="white"
          onClick={handleEdit}
        />
      </div>

      {menu.map((item, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            border: settings.showMenuItemBorder.value
              ? `1px solid ${settings.menuItemBorderColor.value}`
              : "none",
            borderRadius: "10px", // border radius küçültüldü
            margin: `${settings.menuItemSpacing.value}px`,
            padding: `${settings.menuItemPadding.value}px`,
            cursor: item.isActive ? "pointer" : "default",
            backgroundColor: settings.menuItemBackgroundColor.value,
            opacity: item.isActive ? 1 : 0.5,
            pointerEvents: item.isActive ? "auto" : "none",
            transition: `background-color ${settings.animationDuration.value}ms`,
          }}
          onClick={item.onClick}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              gap: "0.75rem",
              color:
                item.color === "text-black"
                  ? settings.menuItemTextColor.value
                  : settings.menuItemDangerColor.value,
              textAlign: settings.menuItemAlignment.value,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
              }}
            >
              {settings.showMenuItemIcons.value && item.icon}
              <span
                style={{
                  fontWeight: "600",
                  fontSize: "0.85rem", // menü yazı boyutu küçültüldü
                }}
              >
                {item.title}
              </span>
            </div>
            {settings.showMenuItemArrows.value && (
              <CaretRightIcon
                style={{
                  height: "0.85rem", // ok ikonu küçültüldü
                  width: "0.85rem",
                  color: "#6b7280",
                  position: "relative",
                  right: 0,
                }}
              />
            )}
          </div>
        </div>
      ))}
      {showLogoutModal && (
        <Components.LogoutModal
          settings={settings}
          logOutOnClick={logOutOnClick}
          cancelLogout={cancelLogout}
        />
      )}
      {showDeleteAccountModal && (
        <Components.DeleteAccountModal
          settings={settings}
          confirmDeleteAccount={confirmDeleteAccount}
          cancelDeleteAccount={cancelDeleteAccount}
        />
      )}
    </div>
  );
};
export default Account;